import { LoginForm } from "@/components/login-form"
import { Head } from "@inertiajs/react"

interface LoginProps {
  csrfToken: string
  domainRestriction: string | null
  flash: {
    notice?: string
    alert?: string
  }
}

export default function Login({ csrfToken, domainRestriction, flash }: LoginProps) {
  return (
    <>
      <Head title="Sign In - Operations Center" />
      <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
        {flash.notice && (
          <div className="w-full max-w-sm rounded-lg border border-green-200 bg-green-50 p-4 text-sm text-green-800 dark:border-green-800 dark:bg-green-950 dark:text-green-200">
            {flash.notice}
          </div>
        )}
        {flash.alert && (
          <div className="w-full max-w-sm rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800 dark:border-red-800 dark:bg-red-950 dark:text-red-200">
            {flash.alert}
          </div>
        )}
        <div className="flex w-full max-w-sm flex-col gap-6">
          <a href="/" className="flex items-center gap-2 self-center font-medium">
            <div className="bg-primary text-primary-foreground flex h-6 w-6 items-center justify-center rounded-md text-xs font-bold">
              OC
            </div>
            Operations Center
          </a>
          <LoginForm csrfToken={csrfToken} domainRestriction={domainRestriction} />
        </div>
      </div>
    </>
  )
}
